<template>
  <div>
    <div
      class="mb-2 text-label-m neutral--text text--tone-400 font-weight-medium"
    >
      {{ label }}
    </div>

    <div>
      <v-text-field
        solo
        flat
        :hide-details="hideDetails"
        class="text-body-m base-input neutral--text"
        v-bind="$attrs"
        v-on="$listeners"
        :rules="rules"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseInput',
  props: {
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: true,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss">
.base-input.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  &:focus-within {
    height: 40px !important;
  }
}

.base-input.v-input__control .v-input__slot {
  padding: 12px 12px 12px 12px !important;
}

.v-input.v-text-field.v-input--is-disabled input {
  color: var(--v-neutral-tone-500) !important;
}

.v-input.v-text-field .v-input__control .v-input__slot {
  border: 1px solid var(--v-neutral-tone-200);
  border-radius: 8px;
}
</style>
